export default __webpack_public_path__ + "static/Room-C-c7f2bfe3ec84d1054ae86622d6667691.jpg";